import React from 'react'

import RatingStars from 'components/rating/RatingStars/RatingStars'

import s from './Rating.scss'


const ReviewRating = ({ rating, starsCount = 5, withMicrodata }) => (
  <div
    {...withMicrodata && {
      itemScope: true,
      itemProp: 'reviewRating',
      itemType: 'http://schema.org/Rating',
    }}
  >
    <RatingStars
      className={s.rating}
      md
      value={rating}
      count={starsCount}
    />
    {
      withMicrodata && (
        <div style={{ display: 'none' }}>
          Rated
          <span itemProp="ratingValue">{rating}</span>
          on the scale of
          <span itemProp="worstRating">0</span>
          to
          <span itemProp="bestRating">{starsCount}</span>
        </div>
      )
    }
  </div>
)


export default ReviewRating
